import React from 'react';
import PropTypes from 'prop-types';

import { SuiContainer } from '@splashthat/sui';

import './FormStyleEditorHeader.styl';

const BASE_COMPONENT_NAME = 'FormStyleEditorHeader';

const FormStyleEditorHeader = ({ label, qaId }) => (
    <SuiContainer
        variation="flex-horizontal-centered"
        className={BASE_COMPONENT_NAME}
        data-qa={`formStyleHeader--${qaId}`}
    >
        <h3 className={`${BASE_COMPONENT_NAME}__text`}>{label}</h3>
    </SuiContainer>
);

FormStyleEditorHeader.propTypes = {
    label: PropTypes.string.isRequired,
    qaId: PropTypes.string.isRequired,
};

export default FormStyleEditorHeader;
